import { Card, Typography, Input, Button, Form, DatePicker, Table } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import "jspdf-autotable";
import { Link, useParams } from "react-router-dom";
import { changeLoader } from "../../../../../../../redux/reducers/loader";
import globalRequest from "../../../../../../../utils/global/globalRequest";
import toast from "react-hot-toast";
import * as Apis from "../../../../../../../utils/helper/enum";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { paginationLimit } from "../../../../../../../utils/helper/constants";
import { debounce } from "lodash";
import * as Validation from "../../../../../../../utils/helper/validation";
import { useLocation } from "react-router-dom";
import { exportCSV, exportPDf, getTabFromOrderStatus, roundToDecimal } from "../../../../../../../utils/helper/utils";
import { useNavigate } from "react-router-dom";

const expandColumns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    sorter: (a, b) => a.id - b.id,
    render: (text) => text || "-"
  },
  {
    title: "Order Number",
    dataIndex: "OrderNumber",
    key: "OrderNumber",
    render: (text, record) => (
      <Link className="cursor-pointer" to={`/order-management/?order_number=${record?.OrderNumber}`}
        state={{
          orderNumber: record?.OrderNumber,
          activeTab: getTabFromOrderStatus(record?.Status)
        }}
        style={{ color: "#37846B", fontWeight: 500 }}
      >
        {text}
      </Link>
    ),
  },
  {
    title: "Qty",
    dataIndex: "Qty",
    key: "Qty",
  },
  {
    title: "Total Amount",
    dataIndex: "TotalAmount",
    key: "TotalAmount",
  },
];

const ItemOrder = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [form] = Form.useForm();
  const { RangePicker } = DatePicker;
  const { Search } = Input;
  const [dataSource, setDataSource] = useState([]);
  const [paginationModel] = useState(paginationLimit); //setPaginationModel
  const location = useLocation();
  const { search, start_date, end_date } = location.state?.inputData || {};
  const navigate = useNavigate();

  const [inputData, setInputData] = useState({
    search: search,
    start_date: start_date, // Set the start date
    end_date: end_date, // Set the end date
  });
  const tabIndex = location.state?.tabIndex; // Get the tabIndex from location state
  console.log(tabIndex, "tabIndex");
  const handleDateChange = (dates, dateStrings) => {
    const [startdate, enddate] = dateStrings; // Get the date strings from the RangePicker

    // Update the filter with the selected start and end dates
    setInputData((prevState) => ({
      ...prevState,
      start_date: startdate, // Set the start date
      end_date: enddate, // Set the end date
    }));
  };

  const handleSearchDebounced = debounce((value) => {
    setInputData((prev) => ({ ...prev, search: value }));
  }, 300); // Debounce delay in milliseconds (adjust as needed)

  // Fetch orders dynamically for expanded row
  const fetchOrdersForItem = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
      };
      const response = await globalRequest(
        Apis.MANAGE_REPORT.GET_ALL_PAYMENTS_REPORT_BY_ITEM_ORDERS + "/" + id,
        "get",
        {},
        { params: params },
        true
      );
      if (response?.data?.status === "SUCCESS") {
        console.log(response?.data?.data?.data?.data, "respone");
        const orders = response?.data?.data?.data?.data?.map((order, index) => ({
          key: index,
          id: order.id,
          OrderNumber: order.order.orderNumber,
          Qty: order.quantity,
          Status: order.order.status,
          TotalAmount: roundToDecimal(order.totalAmount, 2),
        }));
        console.log(orders, "orders");
        setDataSource(orders);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  const exportData = async (value) => {
    if (value) {
      //api call for get data
      dispatch(changeLoader(true));
      try {
        let params = {
          ...inputData,
          type: "export",
        };
        let response = await globalRequest(
          Apis.MANAGE_REPORT.GET_ALL_PAYMENTS_REPORT_BY_ITEM_ORDERS + "/" + id,
          "get",
          {},
          { params: params },
          true
        );
        let apiResponse = response.data;
        if (apiResponse?.status === "SUCCESS") {
          if (apiResponse?.data) {
            let exportData = [];
            for (let key in apiResponse?.data?.data?.data) {
              let item = apiResponse?.data?.data?.data[key];
              exportData.push({
                OrderNumber: item.order.orderNumber,
                Qty: item.quantity,
                Status: item.order.status,
                TotalAmount: roundToDecimal(item.totalAmount, 2),
              });
            }
            if (exportData.length > 0) {
              if (value === "csv") {
                exportCSV(exportData, "itemOrderReport.csv");
              }
              if (value === "pdf") {
                // Generate the table data
                const headers = ["Id", "order Number", "Qty", "TotalAmount"];
                const rows = exportData.map((item) => [item.id, item.OrderNumber, item.Qty, item.TotalAmount]);
                exportPDf(headers, rows, "itemOrderReport.pdf");
              }
            } else {
              // console.log("No data to export");
            }
          }
        } else {
          toast.error(apiResponse?.message);
        }
      } catch (e) {
        toast.error(e?.message);
      }
      dispatch(changeLoader(false));
    }
  };

  useEffect(() => {
    fetchOrdersForItem();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData, paginationModel]);

  return (
    <>
      <Card>
        <div className="flex flex-wrap justify-between	mb-4 gap-5 ">
          <div className="">
            <Typography className="text-xl font-semibold flex gap-1" align={"left"}>
              <Link to="/report" className="!text-[#176B53]" state={{ 
                  inputData: inputData,
                  mainTabIndex: "1", 
                  subTabIndex: tabIndex 
                }}>
                Reports /{" "}
              </Link>
              <Typography
                className="!text-xl !text-[#176B53] cursor-pointer"
                onClick={() => navigate("/report", { state: { inputData: inputData,
                    mainTabIndex: "1",
                    subTabIndex: tabIndex 
                  } 
                })}
              >
                Sales Reports / Sales By Item
              </Typography>
            </Typography>
          </div>
          <div className="flex flex-wrap gap-3">
            <Form form={form} layout="vertical">
              <Form.Item name="search">
                <div className="flex flex-wrap gap-3">
                  <RangePicker
                    className="cursor-pointer"
                    onChange={handleDateChange}
                    value={[
                      inputData?.start_date ? dayjs(inputData?.start_date, "YYYY-MM-DD") : null,
                      inputData?.end_date ? dayjs(inputData?.end_date, "YYYY-MM-DD") : null,
                    ]}
                    // defaultValue={ inputData.start_date && inputData.end_date ? [dayjs(inputData.start_date, 'YYYY-MM-DD'), dayjs(inputData.end_date, 'YYYY-MM-DD')] : null}
                    format="YYYY-MM-DD"
                  />
                  <Search
                    placeholder="Search"
                    style={{
                      width: window.innerWidth < 768 ? "100%" : 200,
                    }}
                    // value={inputData?.search}
                    className="cursor-pointer"
                    onChange={(e) => {
                      const value = Validation.strFormat(e.target.value, "trim");
                      handleSearchDebounced(value); // Debounced function
                    }}
                  />
                </div>
              </Form.Item>
            </Form>
            <div className="flex flex-wrap gap-3">
              <>
                <Button
                  type="primary"
                  size={14}
                  icon={<DownloadOutlined />}
                  className="cursor-pointer"
                  onClick={() => {
                    exportData("csv");
                  }}
                >
                  Download in CSV
                </Button>
                <Button
                  type="primary"
                  size={14}
                  icon={<DownloadOutlined />}
                  className="cursor-pointer"
                  onClick={() => {
                    exportData("pdf");
                  }}
                >
                  Download in PDF
                </Button>
              </>
            </div>
          </div>
        </div>
        <Table columns={expandColumns} dataSource={dataSource} className="multi-tables responsive" pagination={true} />
      </Card>
    </>
  );
};
export default ItemOrder;
